
<button kendoButton
        [ngClass]="{'val-simple-bouton-desactive': desactive}"
        class="val-simple-bouton"
        title="{{libelle}}"
        iconClass="{{iconeClass}}"
        (click)="Click()"
>
{{libelle}}
</button>
